"use client";
import { j as x } from "./jsx-runtime-CJ-St4mQ.mjs";
import { createContext as i, useContext as c } from "react";
const o = i(
  void 0
), v = () => {
  const t = c(o);
  return t || {};
}, C = ({
  children: t,
  variant: r,
  orientation: e,
  color: n,
  size: u,
  fullWidth: s
}) => /* @__PURE__ */ x.jsx(
  o.Provider,
  {
    value: { variant: r, color: n, size: u, fullWidth: s, orientation: e },
    children: t
  }
);
export {
  C as ButtonGroupProvider,
  v as useButtonGroupContext
};
